
import Modal from 'react-modal';
import ImageAndPdfViewer from "../../components/common/ImageAndPdfViewer";
import { handleKeyDown, isMobile } from '../../utils/utils';

type UploadFilePreviewModalProps = {
  isOpen?: boolean;
  file: File;
  onUploadAction?: () => void;
  onCloseModal: () => void;   
  buttonName?: string;
  showButton?: boolean; 
  showSubTitle?: boolean;
  };
  
  
  
  export default function UploadFilePreviewModal({
    file, onUploadAction, isOpen = false, onCloseModal, buttonName, showButton = true, showSubTitle = true
  }: UploadFilePreviewModalProps) {
    Modal.setAppElement("#root");

    const pageWidth = window.innerWidth * 0.9 < 850 ?  window.innerWidth * 0.9 : 850;
    const imagePdfViewerProps = {
      file: file,
      pageWidth: pageWidth,
      closeModal: onCloseModal
    };

    const imagePdfViewerMobileProps = {
      file: file,
      pageWidth: window.innerWidth,
      closeModal: onCloseModal,
      overflow: 'scroll'
    };

    const style = {
      maxWidth: pageWidth,
      display: 'flex',
      flexDirection: 'column',
    };

    const onUpload = (e: any) => {
      e.preventDefault();
      if (onUploadAction) {
        onUploadAction();
      }
      onCloseModal();
    }

    if (isMobile()) {
      return (
        <div className='preview-mobile'>
          <div className='header-reviewer bg-noir p-md blanc'>
                  <p>{file?.name}</p>
                  <i className="fz-xl" onClick={onCloseModal} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>×</i>
                 
                </div>
                <div id={"viewerZone"} style={{ overflow: 'scroll', flex: 1, textAlign: "center" }}>
                  <ImageAndPdfViewer {...imagePdfViewerMobileProps} />
                </div>
                {
                  showButton ?
                  <div className="mt-md pt-lg pb-xl ta-center bg-glace footer-preview" style={{zIndex: 100}}>
                    {showSubTitle && 
                      <strong className="mb-md p-x-xs bleu" style={{display: "block"}}>Est-ce bien le document que vous souhaitez télécharger ?</strong>
                    }
                    <button className="cta-bleu cta-small withicon" onClick={(e) => onUpload(e)} disabled={!file}>
                      <i className="icon-check blanc"></i>
                      {buttonName ? buttonName : 'Confirmer'}
                    </button>
                  </div>
                  :
                  <div className="mt-md"></div>
                }
        </div>
      )
    }

    return (
      <Modal isOpen={isOpen} onRequestClose={onCloseModal} shouldFocusAfterRender={false}>
        <div className="modale open">
          <div className="modale--content">
            <div className="modale--content--template">
              <div className="modale--main-width-entreprise shadow-bleu bg-noir-35" style={style as React.CSSProperties} >
                <div className='header-reviewer bg-noir p-md blanc'>
                  <p>{file?.name}</p>
                  <i className="fz-xl" onClick={onCloseModal} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>×</i>
                 
                </div>
                <div id={"viewerZone"} style={{ overflow: 'overlay', flex: 1 }}>
                  <ImageAndPdfViewer {...imagePdfViewerProps} />
                </div>
                {
                  showButton ?
                  <div className="mt-md p-y-md ta-center bg-glace" style={{zIndex: 100}}>
                    {showSubTitle &&
                      <strong className="mb-md p-x-xs bleu" style={{display: "block"}}>Est-ce bien le document que vous souhaitez télécharger ?</strong>
                    }
                    <button className="cta-bleu cta-small withicon" onClick={(e) => onUpload(e)} disabled={!file}>
                      <i className="icon-check blanc"></i>
                      {buttonName ? buttonName : 'Confirmer'}
                    </button>
                  </div>
                  :
                  <div className="mt-md"></div>
                }
                
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }